import { createUseStyles } from "react-jss";
import { colors } from "../../../../styles/colors";

const useStyles = createUseStyles((_) => ({
  contentMain: {
    overflow: "hidden",
    height: "var(--app-vh)",
  },
  eventRoot: {
    padding: "20px clamp(16px, 3vw, 30px)",
    height: "var(--app-vh)",
    backgroundColor: colors.bgcolor,
    "@media (max-width:899.95px)": { paddingTop: "68px" },
  },
  container: {
    "@media (max-width:899.95px)": { width: "100%" },
    display: "flex",
    flexDirection: "column",
    gap: "30px",
    height: "100%",
  },
  containerHeader: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  headerIconContainer: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginTop: "8px",
  },
  buttonContainer: {
    display: "flex",
    gap: "15px",
    alignItems: "center",
  },
  formContainer: {
    flex: 1,
    overflow: "auto",
    paddingBottom: "20px",
  },
  formCard: {
    backgroundColor: colors.surface,
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    padding: "30px",
  },
  sectionTitle: {
    marginBottom: "30px",
    paddingBottom: "15px",
    borderBottom: `1px solid ${colors.borderLight}`,
  },
  cardContent: {
    padding: "20px",
  },
  formRow: {
    display: "flex",
    gap: "20px",
    marginBottom: "25px",
    
    "@media (max-width:899.95px)": {
      flexDirection: "column",
      gap: "15px",
    },
  },
  formField: {
    flex: 1,
    minWidth: 0, // Prevents flex items from overflowing
  },
  formFieldFull: {
    width: "100%",
  },
}));

export default useStyles;